import { type FC } from 'react';

type Props = {
    title?: string;
};

// DL Fork: generic product name in browser tab titles.
const APP_NAME = 'DataLink Analytics';
const PREFIX = import.meta.env.DEV ? '(DEV) ' : '';

export const DocumentTitle: FC<Props> = ({ title }) => {
    const fullTitle = title
        ? `${PREFIX}${title} - ${APP_NAME}`
        : `${PREFIX}${APP_NAME}`;
    return <title>{fullTitle}</title>;
};
